import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { setIncidentDate } from 'containers/App/actions';
import { makeSelectMedicalHardshipStep, makeSelectMedicalHardshipStepErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  resetFormTravelDelay,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import {
  ErrorMessage,
  Validate,
} from '../../../components/Validation';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import HelpText from '../../../components/HelpText';
import AsyncButtonSendMail from '../../../components/AsyncButtonSendMail/index';
import {
  emailDuesProtectDocument,
} from '../../FastCover/actions';
import MedicalHardshipStepShared from './components/MedicalHardshipStepShared';
import { makeSelectStepWhatHappened } from '../StepWhatHappened/selectors';
import { medicalHardshipLookup } from '../../FastCover/dataMapper/claimCodeMapper';
export class MedicalHardshipStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  handleEmailMeButtonClick = (propertyName) => (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.sendPhysicianEmail(propertyName);
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    this.props.setIncidentDate(dayWithoutTimeZone);
  };

  handleReasonsForTripInterruption = (propertyName) => (event) => {
    const { reasonsForTripInterruption } = this.props.form;
    const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
    ? reasonsForTripInterruption.toJS()
    : reasonsForTripInterruption || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
  };

  handleReasonsForDelay = (propertyName) => (event) => {
    const { reasonsForDelay } = this.props.form;
    const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
    ? reasonsForDelay.toJS()
    : reasonsForDelay || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }

  renderCriticalForm() {
    const {
      whatEventHappenedForCritical,
      areYouInACareFacilityCurrentlyForCritical,
      whatDateThisOccur,
      typeOfCareFacilityForCritical,
      enableTimeForCritical,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted } = this.props;
    const buttonEmailMeDisable = !!enableTimeForCritical && new Date().getTime() < enableTimeForCritical;
    const isReadOnly = submitted || isSummary;
    return (
      <div className={'ml-2'}>
        <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.criticalIllness} />
                </PageSectionHeader>
              </div>
        </div>      
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.whatEventHappened} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Cancer"
                    checked={whatEventHappenedForCritical === 'Cancer'}
                    onChange={this.handleChange('form.whatEventHappenedForCritical')}
                  />
                  <FormattedMessage {...messages.cancer} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Coronary Heart Disease"
                    checked={whatEventHappenedForCritical === 'Coronary Heart Disease'}
                    onChange={this.handleChange('form.whatEventHappenedForCritical')}
                  />
                  <FormattedMessage {...messages.coronaryHeartDisease} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Heart Attack"
                    checked={whatEventHappenedForCritical === 'Heart Attack'}
                    onChange={this.handleChange('form.whatEventHappenedForCritical')}
                  />
                  <FormattedMessage {...messages.heartAttack} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Stroke"
                    checked={whatEventHappenedForCritical === 'Stroke'}
                    onChange={this.handleChange('form.whatEventHappenedForCritical')}
                  />
                  <FormattedMessage {...messages.stroke} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-6 form-group'}>
                <Validate
                  name="whatDateThisOccur"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={whatDateThisOccur}
                  fieldName={messages.whatDateThisOccur}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="whatDateThisOccur"
                    type="text"
                    onDayChange={this.handleDayChange('form.whatDateThisOccur')}
                    value={whatDateThisOccur}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.whatDateThisOccur}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.whatDateThisOccur}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouInACareFacilityCurrently} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouInACareFacilityCurrentlyForCritical === 'true'}
                    onChange={this.handleChange('form.areYouInACareFacilityCurrentlyForCritical')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouInACareFacilityCurrentlyForCritical === 'false'}
                    onChange={this.handleChange('form.areYouInACareFacilityCurrentlyForCritical')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        {areYouInACareFacilityCurrentlyForCritical === 'true' &&
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
            <Validate
              name="typeOfCareFacilityForCritical"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={typeOfCareFacilityForCritical}
              fieldName={messages.typeOfCareFacility}                  
              >
                <Textbox
                  disabled={isReadOnly}
                  name="typeOfCareFacilityForCritical"
                  type="text"
                  onChange={this.handleChange('form.typeOfCareFacilityForCritical')}
                  value={typeOfCareFacilityForCritical}
                  isSummary={isSummary}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.typeOfCareFacility}
                  />
                </ErrorMessage>
              </Validate>
          </div>
        </div>
        }
        <div className={'ml-2 row'}>
              <div className={'form-group col-sm-7'}>
                <HelpText>
                On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                </HelpText>
              </div>
              <div className={'form-group col-sm-5'}>
                <AsyncButtonSendMail
                  id={this.emailMeDocumentButton}
                  className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                  disabled={buttonEmailMeDisable || isReadOnly}
                  loading={this.props.loading}
                  spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                  onClick={this.handleEmailMeButtonClick('form.enableTimeForCritical')}
                >
                  Statement of Attending Physician
                </AsyncButtonSendMail>
              </div>
            </div>
      </div>
    );
  }

  renderDisabilityForm() {
    const {
      whatEventHappenedForDisability,
      dateOfAccidentForDisability,
      areYouInACareFacilityCurrentlyForDisability,
      typeOfCareFacilityForDisability,
      enableTimeForDisability,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted } = this.props;
    const buttonEmailMeDisable = !!enableTimeForDisability && new Date().getTime() < enableTimeForDisability;
    const isReadOnly = submitted || isSummary;
    return (
      <div className={'ml-2'}>
        <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.disability} />
                </PageSectionHeader>
              </div>
        </div>      
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.whatEventHappened} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Illness"
                    checked={whatEventHappenedForDisability === 'Illness'}
                    onChange={this.handleChange('form.whatEventHappenedForDisability')}
                  />
                  <FormattedMessage {...messages.illness} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Injury"
                    checked={whatEventHappenedForDisability === 'Injury'}
                    onChange={this.handleChange('form.whatEventHappenedForDisability')}
                  />
                  <FormattedMessage {...messages.injury} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-6 form-group'}>
                <Validate
                  name="whatDateDidThisOccurForDismemberment"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfAccidentForDisability}
                  fieldName={messages.whatDateThisOccur}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateOfAccidentForDisability"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfAccidentForDisability')}
                    value={dateOfAccidentForDisability}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.whatDateThisOccur}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfAccident}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouInACareFacilityCurrently} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouInACareFacilityCurrentlyForDisability === 'true'}
                    onChange={this.handleChange('form.areYouInACareFacilityCurrentlyForDisability')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouInACareFacilityCurrentlyForDisability === 'false'}
                    onChange={this.handleChange('form.areYouInACareFacilityCurrentlyForDisability')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        {areYouInACareFacilityCurrentlyForDisability === 'true' &&
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
            <Validate
              name="typeOfCareFacilityForDisability"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={typeOfCareFacilityForDisability}
              fieldName={messages.typeOfCareFacility}                  
              >
                <Textbox
                  disabled={isReadOnly}
                  name="typeOfCareFacilityForDisability"
                  type="text"
                  onChange={this.handleChange('form.typeOfCareFacilityForDisability')}
                  value={typeOfCareFacilityForDisability}
                  isSummary={isSummary}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.typeOfCareFacility}
                  />
                </ErrorMessage>
              </Validate>
          </div>
        </div>}
        <div className={'ml-2 row'}>
              <div className={'form-group col-sm-7'}>
                <HelpText>
                On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                </HelpText>
              </div>
              <div className={'form-group col-sm-5'}>
                <AsyncButtonSendMail
                  id={this.emailMeDocumentButton}
                  className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                  disabled={buttonEmailMeDisable || isReadOnly}
                  loading={this.props.loading}
                  spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                  onClick={this.handleEmailMeButtonClick('form.enableTimeForDisability')}
                >
                  Statement of Attending Physician
                </AsyncButtonSendMail>
              </div>
            </div>
      </div>
    );
  }

  renderDismembermentForm() {
    const {
      natureOfDismemberment,
      areYouInACareFacilityCurrentlyForDismemberment,
      whatDateDidThisOccurForDismemberment,
      didYouGoToAHospitalCurrentlyForDismemberment,
      typeOfCareFacilityForDismemberment,
      enableTimeForDismemberment,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted } = this.props;
    const buttonEmailMeDisable = !!enableTimeForDismemberment && new Date().getTime() < enableTimeForDismemberment;
    const isReadOnly = submitted || isSummary;
    return (
      <div className={'ml-2'}>
        <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.natureOfDismemberment} />
                </PageSectionHeader>
              </div>
        </div>
        <div className={'ml-2 row'}>
            <div className={'col-sm-12 form-group'}>
              <Validate
                name="natureOfDismemberment"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={natureOfDismemberment}
                fieldName={messages.natureOfDismemberment}
                >
                    <FlexBox className={'pt-2'}>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="false"
                          name="Both hands or both feet"
                          checked={natureOfDismemberment === 'Both hands or both feet'}
                          onChange={this.handleChangeClaimingFor('form.natureOfDismemberment')}
                        />
                        <FormattedMessage {...messages.bothHandsOrBothFeet} />
                      </OptionsContainer>
                    </FlexBox>
                    <FlexBox className={'pt-2'}>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="One hand and one foot"
                          checked={natureOfDismemberment === 'One hand and one foot'}
                          onChange={this.handleChange('form.natureOfDismemberment')}
                        />
                        <FormattedMessage {...messages.sightOfBothEyes} />
                      </OptionsContainer>
                    </FlexBox>
                    <FlexBox className={'pt-2'}>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="Heart Attack"
                          checked={natureOfDismemberment === 'Heart Attack'}
                          onChange={this.handleChange('form.natureOfDismemberment')}
                        />
                        <FormattedMessage {...messages.oneHandAndOneFoot} />
                      </OptionsContainer>
                    </FlexBox>
                    <FlexBox className={'pt-2'}>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="One arm from the shoulder down to the hand"
                          checked={natureOfDismemberment === 'One arm from the shoulder down to the hand'}
                          onChange={this.handleChange('form.natureOfDismemberment')}
                        />
                        <FormattedMessage {...messages.oneArmFromTheShoulderDownToTheHand} />
                      </OptionsContainer>
                    </FlexBox>
                    <FlexBox className={'pt-2'}>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="One leg from the hip down to the foot"
                          checked={natureOfDismemberment === 'One leg from the hip down to the foot'}
                          onChange={this.handleChange('form.natureOfDismemberment')}
                        />
                        <FormattedMessage {...messages.oneLegFromTheHipDownToTheFoot} />
                      </OptionsContainer>
                    </FlexBox>
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.natureOfDismemberment}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-6 form-group'}>
                <Validate
                  name="whatDateDidThisOccurForDismemberment"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={whatDateDidThisOccurForDismemberment}
                  fieldName={messages.whatDateThisOccur}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="whatDateDidThisOccurForDismemberment"
                    type="text"
                    onDayChange={this.handleDayChange('form.whatDateDidThisOccurForDismemberment')}
                    value={whatDateDidThisOccurForDismemberment}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.whatDateThisOccur}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.whatDateThisOccur}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.didYouGoToAHospitalCurrently} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={didYouGoToAHospitalCurrentlyForDismemberment === 'true'}
                    onChange={this.handleChange('form.didYouGoToAHospitalCurrentlyForDismemberment')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={didYouGoToAHospitalCurrentlyForDismemberment === 'false'}
                    onChange={this.handleChange('form.didYouGoToAHospitalCurrentlyForDismemberment')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouInACareFacilityCurrently} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouInACareFacilityCurrentlyForDismemberment === 'true'}
                    onChange={this.handleChange('form.areYouInACareFacilityCurrentlyForDismemberment')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouInACareFacilityCurrentlyForDismemberment === 'false'}
                    onChange={this.handleChange('form.areYouInACareFacilityCurrentlyForDismemberment')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        {areYouInACareFacilityCurrentlyForDismemberment === 'true' &&
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
            <Validate
              name="typeOfCareFacilityForDismemberment"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={typeOfCareFacilityForDismemberment}
              fieldName={messages.typeOfCareFacility}               
              >
                <Textbox
                  disabled={isReadOnly}
                  name="typeOfCareFacilityForDismemberment"
                  type="text"
                  onChange={this.handleChange('form.typeOfCareFacilityForDismemberment')}
                  value={typeOfCareFacilityForDismemberment}
                  isSummary={isSummary}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.typeOfCareFacility}
                  />
                </ErrorMessage>
              </Validate>
          </div>
        </div>}
        <div className={'ml-2 row'}>
              <div className={'form-group col-sm-7'}>
                <HelpText>
                On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                </HelpText>
              </div>
              <div className={'form-group col-sm-5'}>
                <AsyncButtonSendMail
                  id={this.emailMeDocumentButton}
                  className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                  disabled={buttonEmailMeDisable || isReadOnly}
                  loading={this.props.loading}
                  spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                  onClick={this.handleEmailMeButtonClick}
                >
                  Statement of Attending Physician
                </AsyncButtonSendMail>
              </div>
        </div>
      </div>
    );
  }

  renderLeaveOfAbsenceForm() {
    const {
      didYourEmployerAllowYouAnApprovedLeaveOfAbsence,
      onWhatDateDidYourLeaveStart,
      employerName,
      employerEmail,
      areYouRetired,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className={'ml-2'}>
        <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.leaveOfAbsence} />
                </PageSectionHeader>
              </div>
        </div>      
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.didYourEmployerAllowYouAnApprovedLeaveOfAbsence} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={didYourEmployerAllowYouAnApprovedLeaveOfAbsence === 'true'}
                    onChange={this.handleChange('form.didYourEmployerAllowYouAnApprovedLeaveOfAbsence')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={didYourEmployerAllowYouAnApprovedLeaveOfAbsence === 'false'}
                    onChange={this.handleChange('form.didYourEmployerAllowYouAnApprovedLeaveOfAbsence')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-6 form-group'}>
                <Validate
                  name="onWhatDateDidYourLeaveStart"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={onWhatDateDidYourLeaveStart}
                  fieldName={messages.onWhatDateDidYourLeaveStart}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="onWhatDateDidYourLeaveStart"
                    type="text"
                    onDayChange={this.handleDayChange('form.onWhatDateDidYourLeaveStart')}
                    value={onWhatDateDidYourLeaveStart}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.onWhatDateDidYourLeaveStart}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.whatDateDidThisOccurForDismemberment}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
        </div>
        <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="employerName"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={employerName}
                  fieldName={messages.employerName}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="employerName"
                      type="text"
                      onChange={this.handleChange('form.employerName')}
                      value={employerName}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.employerName}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="employerEmail"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={employerEmail}
                  fieldName={messages.employerEmail}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="employerEmail"
                      type="text"
                      onChange={this.handleChange('form.employerEmail')}
                      value={employerEmail}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.employerEmail}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
                <Validate
                  name="areYouRetired"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={areYouRetired}
                  fieldName={messages.areYouRetired}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="areYouRetired"
                      type="text"
                      onChange={this.handleChange('form.areYouRetired')}
                      value={areYouRetired}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.areYouRetired}
                      />
                    </ErrorMessage>
                  </Validate>
          </div>
        </div>
        <div>
          <MedicalHardshipStepShared />
        </div>
      </div>
    );
  }

  renderDeathForm() {
    const {
      dateOfDeath,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className={'ml-2'}>
        <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.death} />
                </PageSectionHeader>
              </div>
        </div>      
        <div className={'ml-2 row'}>
          <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateOfDeath"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfDeath}
                  fieldName={messages.dateOfDeath}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateOfDeath"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfDeath')}
                    value={dateOfDeath}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfDeath}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfDeath}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { selectedBenefits } = this.props.stepWhatHappenedData;
    const list =
      !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
        ? selectedBenefits.toJS()
        : selectedBenefits || [];
    const { isSummary, submitted, loading } = this.props;
    const isReadOnly = submitted || isSummary;
    const isRenderCritical = list.filter((m) => m.claimCode === medicalHardshipLookup.criticalIllness.claimCode).length > 0;
    const isRenderDisability = list.filter((m) => m.claimCode === medicalHardshipLookup.disability.claimCode).length > 0;
    const isRenderDismemberment = list.filter((m) => m.claimCode === medicalHardshipLookup.dismemberment.claimCode).length > 0;
    const isRenderLeaveOfAbsence = list.filter((m) => m.claimCode === medicalHardshipLookup.leaveOfAbsence.claimCode).length > 0;
    const isRenderDeath = list.filter((m) => m.claimCode === medicalHardshipLookup.death.claimCode).length > 0;
    return (
      <div className="app-content height-dues-protect">
        {isRenderCritical && this.renderCriticalForm()}
        {isRenderDisability && this.renderDisabilityForm()}
        {isRenderDismemberment && this.renderDismembermentForm()}
        {isRenderLeaveOfAbsence && this.renderLeaveOfAbsenceForm()}
        {isRenderDeath && this.renderDeathForm()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

MedicalHardshipStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  sendPhysicianEmail: PropTypes.func,
  setIncidentDate: PropTypes.func,
  stepWhatHappenedData: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectMedicalHardshipStep(),
  errors: makeSelectMedicalHardshipStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  stepWhatHappenedData: makeSelectStepWhatHappened(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormData: () => dispatch(resetFormData()),
  sendPhysicianEmail: (propertyName) => dispatch(emailDuesProtectDocument(propertyName)),
  setIncidentDate: (date) => dispatch(setIncidentDate(date)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'medicalHardshipStep', reducer });

export default compose(
  withReducer,
  withConnect
)(MedicalHardshipStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.MedicalHardshipStep/index.js